import { BoxV2 as Box } from 'portal-commons';
import { FC } from 'react';

import { Section, SectionItem, SectionTitle } from './atoms';
import { CampaignDetail } from '@/apis/core';

interface MessageProgramDetailsSectionProps {
  campaign: CampaignDetail;
}

export const MessageProgramDetailsSection: FC<
  MessageProgramDetailsSectionProps
> = ({ campaign }) => (
  <Section>
    <SectionTitle>Message Program Details</SectionTitle>
    <SectionItem title="Program Description">
      <Box
        sx={{
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 3,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {campaign.description}
      </Box>
    </SectionItem>
  </Section>
);

export default MessageProgramDetailsSection;
